<div (openChange)="startFilter()" autoClose="outside" class="filter-dropdown" ngbDropdown>
  <app-tooltip [dynamic]="false" class="display-inline-flex" message="Filter">
    <button [attr.data-cy]="filterName + '-filter-button'" [ngClass]="getCssButton()"
      class="filter filter-icon iwp-icon-gen_filter"
      ngbDropdownToggle
      tabIndex="-1"
    type="button"></button>
  </app-tooltip>

  <div class="filter-menu" ngbDropdownMenu placement="'bottom-right'">
    @if (spinnerObservable | async) {
      <div class="spinner-container">
        <app-loading-spinner class="center-spinner"></app-loading-spinner>
      </div>
    }
    <div class="filter-all">
      <app-input-text
        #searchInput
        (keydown.enter)="closeAndSearch()"
        [hasLabel]="false"
        [hasSearchIcon]="true"
        [placeholder]="placeHolder"
        [alternateBackground]="true"
        (inputValueChange)="updateSearchInputFilters($event)"
        class="filter-search-input"
        [baseCypressTag]="getCypressTag()">
      </app-input-text>
    </div>
    <div class="filter-item">
      <input (change)="toggleAllCode($event)" (keydown.enter)="closeAndSearch()"
        [attr.data-cy]="filterName + '-input-filter-all'"
        [checked]="allFilter.checked"
        [indeterminate]="allFilter.indeterminate"
        class="filter-item-code-input"
        id="{{filterName}}-input-filter-all" type="checkbox">
      <label [attr.data-cy]="filterName + '-input-filter-all-label'" [textContent]="allFilter.name"
      class="filter-option-label" for="{{filterName}}-input-filter-all"></label>
    </div>
    @if (codes?.length > 0 || hasEmptyOption) {
      <div class="separator"></div>
    }
    @if (hasEmptyOption) {
      <div class="filter-item">
        <input (change)="toggleEmptyCode($event)" (keydown.enter)="closeAndSearch()"
          [attr.data-cy]="filterName + '-input-filter-empty'"
          [checked]="emptyFilter.checked"
          class="filter-item-code-input"
          id="{{filterName}}-input-filter-empty" type="checkbox">
        <label [attr.data-cy]="filterName + '-input-filter-empty-label'" [textContent]="emptyFilter.name"
        class="filter-option-label" for="{{filterName}}-input-filter-empty"></label>
      </div>
    }
    @if (!hasEmptyOption) {
      <div [attr.data-cy]="filterName + '-filter-scroll'" class="filter-scroll">
        @for (code of codes; track code; let index = $index) {
          <div [attr.data-cy]="filterName + '-filter-item'" class="filter-item">
            <input (change)="toggleCode(code, $event)" (keydown.enter)="closeAndSearch()"
              [attr.data-cy]="filterName + '-filter-item-input-' + code.code"
              [checked]="code.checked"
              class="filter-item-code-input"
              id="{{filterName}}-input-filter-{{code.code}}-{{index}}"
              type="checkbox">
            <label [attr.data-cy]="filterName + '-filter-item-' + code.code"
              [textContent]="code | prettyPrintReference: formatWithoutCode"
              class="filter-item-code-label"
            for="{{filterName}}-input-filter-{{code.code}}-{{index}}"></label>
            <div></div>
          </div>
        }
      </div>
    }
    <app-filter-footer
      (applyClick)="closeAndSearch()"
      (clearClick)="clear()"
    [filterName]="filterName"></app-filter-footer>
  </div>
</div>
